import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Divider,
} from "@mui/material";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LogoutIcon from "@mui/icons-material/Logout";

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();

  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <AppBar position="static" sx={{ mb: 4 }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          PT Putra Agri Sukses
        </Typography>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Button
            color="inherit"
            component={RouterLink}
            to="/products"
            sx={{
              backgroundColor: isActive("/products")
                ? "rgba(255, 255, 255, 0.1)"
                : "transparent",
            }}
          >
            Products
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/categories"
            sx={{
              backgroundColor: isActive("/categories")
                ? "rgba(255, 255, 255, 0.1)"
                : "transparent",
            }}
          >
            Categories
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/media"
            sx={{
              backgroundColor: isActive("/media")
                ? "rgba(255, 255, 255, 0.1)"
                : "transparent",
            }}
          >
            Media
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/hero-slides"
            sx={{
              backgroundColor: isActive("/hero-slides")
                ? "rgba(255, 255, 255, 0.1)"
                : "transparent",
            }}
          >
            Hero Slides
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/team-members"
            sx={{
              backgroundColor: isActive("/team-members")
                ? "rgba(255, 255, 255, 0.1)"
                : "transparent",
            }}
          >
            Team Members
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/company-info"
            sx={{
              backgroundColor: isActive("/company-info")
                ? "rgba(255, 255, 255, 0.1)"
                : "transparent",
            }}
          >
            Visi & Misi
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/users"
            sx={{
              backgroundColor: isActive("/users")
                ? "rgba(255, 255, 255, 0.1)"
                : "transparent",
            }}
          >
            Users
          </Button>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ mx: 1, bgcolor: "rgba(255,255,255,0.3)" }}
          />
          {user && (
            <Typography variant="body2" sx={{ mr: 2 }}>
              {user.username}
            </Typography>
          )}
          <Button
            color="inherit"
            onClick={handleLogout}
            startIcon={<LogoutIcon />}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;
